export default "__VITE_ASSET__GJ6CjUpp__"